import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
selector: '[numberOnly]'
})
export class NumberOnlyDirective {
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home ,"0","1","2","3","4","5","6","7","8","9","."
    private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home','ArrowRight', 'ArrowLeft' ];

    @Input() numberOnly:string = "";

    constructor(private el: ElementRef) {}

    @HostListener('keydown', [ '$event' ])
    onkeydown(event: KeyboardEvent) {
        
        let current: string = this.el.nativeElement.value;
        let cursorPostion:number = this.el.nativeElement.selectionStart;
        let key: string = event.key;

        if(this.specialKeys.indexOf(key) == -1){
            
            let newString = this.createPosableValue(current, cursorPostion,key);
            let valid = this.validateInput(newString, this.numberOnly);
            
            if(!valid){
                event.preventDefault();
            }
        }
    }

    private createPosableValue(current:string, cusorPosition:number, newKey:string){
        
        let stringList = current.split("");
        let newString:string = "";

        if(cusorPosition == 0){
            newString = newKey+current
        }else if(cusorPosition == stringList.length){
            newString = current+newKey
        }else{
            for(let i = 0; i<stringList.length; i++){
                if(i == cusorPosition){
                    newString = newString + newKey + stringList[i];
                }else{
                    newString = newString + stringList[i]
                }
            }
        }
        return newString
    }

    validateInput(text:string, code:string){
        if (text) {
            let newtext:any;
            let regularExpresion:RegExp;

            if(code === "3"){
                regularExpresion = new RegExp(/[0-9]{0,10}[\.]?[0-9]{0,3}/g);
            }else if (code === "0"){
                regularExpresion = new RegExp(/[0-9]{0,10}/g);
            }else if (code === "1"){
                regularExpresion = RegExp(/[0-9]{0,2}[\.]?[0-9]{0,1}/g);
            }else if(code === "2,2"){
                regularExpresion = new RegExp(/[0-9]{0,2}[\.]?[0-9]{0,2}/g);
            }else if(code === "2,1"){
                regularExpresion = new RegExp(/[0-9]{0,2}[\.]?[0-9]{0,1}/g);
            }else if(code === "3.0"){
                regularExpresion = new RegExp(/[0-9]{0,3}/g);
            }else if(code === "4.0"){
                regularExpresion = new RegExp(/[0-9]{0,4}/g);
            }else if(code==="8"){
                regularExpresion = new RegExp(/[0-9]{0,8}/g);
            }else if(code === "?.1"){
                regularExpresion = new RegExp(/[0-9]{0,10}[\.]?[0-9]{0,1}/g);
            }else{
                regularExpresion = new RegExp(/[0-9]{0,10}[\.]?[0-9]{0,2}/g);
            }
            newtext= regularExpresion.exec(text);
            newtext= ""+newtext+"";
            if(newtext !== text){
                return false;
            }else{
                return true;
            }
        }else{
            return false;
        }
    }
}